module.exports = __webpack_public_path__ + "img/comentarios.1388f8d7.png";